import { Routes } from '@angular/router';
import { DefaultLayoutComponent, EmailLayoutComponent } from './layout';
import { PartnersComponent } from './views/settings/partners/partners.component';
import { PartnerpageComponent } from './views/settings/partnerpage/partnerpage.component';
import { CreatelicenseComponent } from './views/settings/createlicense/createlicense.component';
import { ClientsComponent } from './views/settings/clients/clients.component';
import { ClientpageComponent } from './views/settings/clientpage/clientpage.component';
import { InvoicedetailComponent } from './views/settings/invoicedetail/invoicedetail.component';
import { InvoicesComponent } from './views/settings/invoices/invoices.component';
import { NFRLicenseComponent } from './views/settings/nfrlicense/nfrlicense.component';
import { RolesComponent } from './views/settings/roles/roles.component';
import { UsersComponent } from './views/settings/users/users.component';
import { RolepageComponent } from './views/settings/rolepage/rolepage.component';
import { UserpageComponent } from './views/settings/userpage/userpage.component';
import { PartnerpackagesComponent } from './views/settings/partnerpackages/partnerpackages.component';
import { LicensedurationsComponent } from './views/settings/licensedurations/licensedurations.component';
import { EmailConfigComponent } from './views/settings/email-config/email-config.component';
import { LicenseComponent } from './views/settings/license/license.component';
  

export const routes: Routes = [
  {
    path: '',
    redirectTo: 'login',
    pathMatch: 'full'
  },
  {
    path: 'apps/email',
    component: EmailLayoutComponent,

    children: [
      {
        path: '',
        loadChildren: () => import('./views/apps/email/routes').then((m) => m.routes)
      }
    ]
  },
  {
    path: '',
    component: DefaultLayoutComponent,
    data: {
      title: ''
    },
    children: [
      {
        path: 'test',
        loadChildren: () => import('./views/test/test.module').then((m) => m.TestModule)
      },
      {
        path: 'products',
        loadChildren: () => import('./views/products/products.module').then((m) => m.ProductsModule)
      },

      {
        path: 'partners',
        children: [
          {
            path:'',
            component: PartnersComponent,
            data: {
              title: 'Partners',
            },
          },
        ],
      },
      {
        path: 'plans',
        children: [
          {
            path:'',
            component: CreatelicenseComponent,
            data: {
              title: 'Plans',
            },
          },
        ],
      },
      {
        path: 'subscriptions',
        children: [
          {
            path:'',
            component: LicenseComponent,
            data: {
              title: 'Subscriptions',
            },
          },
        ],
      },

        // {
        //         path: 'roles',
        //         component: RolesComponent,
        //         data: {
        //           title: 'Roles',
        //         },
        //       }, 
        //       {
        //         path: 'users',
        //         component: UsersComponent,
        //         data: {
        //           title: 'Users',
        //         },
        //       },
        //       {
        //         path: 'rolepage',
        //         component: RolepageComponent,
        //         data: {
        //           title: 'Role Page',
        //         },
        //       },
        //       {
        //         path: 'userpage',
        //         component: UserpageComponent,
        //         data: {
        //           title: 'User Page',
        //         },
        //       },
        //       {
        //         path: 'partnerlevels',
        //         component: PartnerpackagesComponent,
        //         data: {
        //           title: 'Partner Levels',
        //         },
        //       },
        //       {
        //         path: 'licensedurations',
        //         component: LicensedurationsComponent,
        //         data: {
        //           title: 'License Durations',
        //         },
        //       },
        //       {
        //         path: 'emailconfig',
        //         component: EmailConfigComponent,
        //         data: {
        //           title: 'Email Config',
        //         },
        //       },

      {
        path: 'partnerpage',
        component: PartnerpageComponent,
        data: {
          title: 'Partner Page',
        },
      },
      {
        path: 'clients',
        component: ClientsComponent,
        data: {
          title: 'Clients',
        },
      },
      
      {
        path: 'clientpage',
        component: ClientpageComponent,
        data: {
          title: 'Client Page',
        },
      },
      {
        path: 'invoices',
        component: InvoicesComponent,
        data: {
          title: 'Invoices',
        },
      },
      {
        path: 'invoicedetail',
        component: InvoicedetailComponent,
        data: {
          title: 'Invoice Detail',
        },
      },
      {
        path: 'nfrlicense',
        component: NFRLicenseComponent,
        data: {
          title: 'NFR License',
        },
      },
      {
        path: 'profile',
        loadComponent: () => import('./views/profile/profile.component').then(m => m.ProfileComponent),
        data: {
          title: 'Profile'
        }
      },
      {
        path: 'settings',
        loadChildren: () => import('./views/settings/settings.module').then((m) => m.SettingsModule)
      },
      {
        path: 'dashboard',
        loadChildren: () => import('./views/dashboard/routes').then((m) => m.routes)
      },
      {
        path: 'theme',
        loadChildren: () => import('./views/theme/routes').then((m) => m.routes)
      },
      {
        path: 'base',
        loadChildren: () => import('./views/base/routes').then((m) => m.routes)
      },
      {
        path: 'buttons',
        loadChildren: () => import('./views/buttons/routes').then((m) => m.routes)
      },
      {
        path: 'forms',
        loadChildren: () => import('./views/forms/routes').then((m) => m.routes)
      },
      {
        path: 'icons',
        loadChildren: () => import('./views/icons/routes').then((m) => m.routes)
      },
      {
        path: 'notifications',
        loadChildren: () => import('./views/notifications/routes').then((m) => m.routes)
      },
      {
        path: 'widgets',
        loadChildren: () => import('./views/widgets/routes').then((m) => m.routes)
      },
      {
        path: 'smart-table',
        loadChildren: () => import('./views/smart-tables/routes').then((m) => m.routes)
      },
      {
        path: 'plugins',
        loadChildren: () => import('./views/plugins/routes').then((m) => m.routes)
      },
      {
        path: 'pages',
        loadChildren: () => import('./views/pages/routes').then((m) => m.routes)
      },
      {
        path: 'apps',
        loadChildren: () => import('./views/apps/routes').then((m) => m.routes)
      }
    ]
  },
  {
    path: '404',
    loadComponent: () => import('./views/pages/page404/page404.component').then(m => m.Page404Component),
    data: {
      title: 'Page 404'
    }
  },
  {
    path: '500',
    loadComponent: () => import('./views/pages/page500/page500.component').then(m => m.Page500Component),
    data: {
      title: 'Page 500'
    }
  },
  {
    path: 'login',
    loadComponent: () => import('./views/pages/login/login.component').then(m => m.LoginComponent),
    data: {
      title: 'Login Page'
    }
  },
  {
    path: 'forgotpassword',
    loadComponent: () => import('./views/pages/forgotpassword/forgotpassword.component').then(m => m.ForgotpasswordComponent),
    data: {
      title: 'Forgot Password Page'
    }
  },
  {
    path: 'login-processing',
    loadComponent: () => import('./views/pages/loading-screen/loading-screen.component').then(m => m.LoadingScreenComponent),
    data: {
      title: 'Login Processing Page'
    }
  },
  {
    path: 'Invoice/:id',
    loadComponent: () => import('./views/settings/invoicedetail/invoicedetail.component').then(m => m.InvoicedetailComponent),
    data: {
      title: 'Invoice'
    }
  },
  {
    path: 'register',
    loadComponent: () => import('./views/pages/register/register.component').then(m => m.RegisterComponent),
    data: {
      title: 'Register Page'
    }
  },
   {
    path: 'x2x-newest',
    loadComponent: () => import('./views/pages/x2xnewest/x2xnewest.component').then(m => m.X2xnewestComponent),
    data: {
      title: 'X2X Newest Page'
    },
    
  },
  {
    path: 'resetpassword',
    loadComponent: () => import('./views/pages/resetpassword/resetpassword.component').then(m => m.ResetpasswordComponent),
    data: {
      title: 'Reset Password Page'
    },
    
  },
  { path: '**', redirectTo: 'dashboard' }
];
